import React from 'react';

import { FormikFormControl, FormikInput } from '@rbilabs/universal-components';

import { t } from 'state/intl/translations';

import { FieldContainer } from './signup.styled';

const PhoneNumberField = ({
  hintMessage,
  isRequired = false,
  onSubmitEditing,
}: {
  hintMessage?: string | null;
  isRequired?: boolean;
  onSubmitEditing?: () => void | Promise<void>;
}) => {
  return (
    <FieldContainer>
      <FormikFormControl isRequired={isRequired} label={t('phoneNumber')} name="phoneNumber">
        <FormikInput
          inputProps={{
            placeholder: `${t('phoneNumber')}`,
            testID: 'signup-phone-input',
            placeholderTextColor: '#979797',
            autoCorrect: false,
            autoComplete: 'tel',
            keyboardType: 'phone-pad',
            returnKeyType: 'done',
            onSubmitEditing,
            // @ts-expect-error TS(2322) FIXME: Type '{ placeholder: string; testID: string; place... Remove this comment to see the full error message
            hintMessage,
          }}
        />
      </FormikFormControl>
    </FieldContainer>
  );
};

export default PhoneNumberField;
